<template>
  <div class="center-item-body">
    <div class="info-top-body">
      <div class="info-top-box">
        <div class="info-top-vip">
          <img src="../../assets/image/info_vip_icon.png" class="info-top-image"/>
          <p class="info-top-title">VIP{{userVip}}</p>
        </div>
        <div class="info-top-progress">
          <span class="info-top-integral">{{userIntegral}}</span>
          <p class="info-top-progress-text">距离升级到VIP{{userNextLevel}}还差{{userNextIntegral}}积分</p>
        </div>
      </div>
      <Progress hide-info :percent="userNextPercent" class="info-progress-bar"></Progress>
      <ul class="info-vip-ul">
        <li class="info-vip-li" v-for="(item,index) in vipTextList" :key="index">
          <img :src="vipList[item.id].vsrc" :class="'vip-level-'+item.id"></img>
          <p class="info-vip-p">{{item.text}}</p>
        </li>
      </ul>
    </div>
    <table class="info-data-table">
      <tr>
        <td class="info-data-td"><span>*</span>姓名:</td>
        <td class="info-data-right-td">{{infoName}}</td>
      </tr>
      <tr>
        <td class="info-data-td"><span>*</span>性别:</td>
        <td class="info-data-right-td">
          <span class="info-data-sex" :class="infoSex == 1 ? 'info-data-sex-active' : ''" @click="selectSex(1)">男</span>
          <span class="info-data-sex ml-10" :class="infoSex == 2 ? 'info-data-sex-active' : ''" @click="selectSex(2)">女</span>
        </td>
      </tr>
      <tr>
        <td class="info-data-td"><span>*</span>出生日期:</td>
        <td class="info-data-right-td">
          {{infoBorn}}
        </td>
      </tr>
      <tr>
        <td class="info-data-td"><span>*</span>QQ:</td>
        <td class="info-data-right-td">
          <input class="info-data-input" type="text" v-model="infoQq" placeholder="请填写QQ号码">
        </td>
      </tr>
      <tr>
        <td class="info-data-td"><span>*</span>地区:</td>
        <td class="info-data-right-td">
          <Cascader class="info-data-cascader" :data="cityList" v-model="infoArea"></Cascader>
        </td>
      </tr>
      <tr>
        <td class="info-data-td"><span>*</span>手机号码</td>
        <td class="info-data-right-td">
          <input class="info-data-input" type="text" v-model="infoPhone" placeholder="请绑定手机号码">
        </td>
      </tr>
    </table>
    <div class="info-submit" @click="submitInfo">保存</div>
  </div>
</template>
 
<script>
  import city from '@/assets/js/country-data.js'
  export default {
    computed:{
      vipList(){
        return this.$store.state.constant.vipList;
      }
    },
    props: {
      parentIntegral:{ //更新头像时发起更新通知
        type:Number,
        default:0
      }
    },
    data() {
      return {
        loginState:false,
        userVip:0, //用户vip
        userIntegral:0,
        userNextLevel:0, //下一级vip
        userNextIntegral:0, //下一级升级积分
        userNextPercent:0, //vip进度
        infoPhone:"", //手机号
        infoArea:[], //地区列表
        infoQq:"",
        infoSex:0,
        infoName:"",
        infoBorn:"",
        cityList: city,
        vipTextList:[
          { id:0, text:"注册玩家" },
          { id:1, text:"大玩家" },
          { id:2, text:"大玩家" },
          { id:3, text:"大玩家" },
          { id:4, text:"超级玩家" },
          { id:5, text:"超级玩家" },
          { id:6, text:"超级玩家" },
          { id:7, text:"头号玩家" },
        ]
      };
    },
    mounted(){
      if (window.sessionStorage.getItem("token") !== null) {
        this.loginState = true;
      }  
      this.queryMineInfo();
    },
    methods:{
      selectSex(value){
        this.infoSex = value;
      },
      queryMineInfo(){
        this.$http.post('/query_mine_info',{})
        .then(res=>{
          if(res.data.code == 2000){
            this.userVip = res.data.data.info_level;
            this.userIntegral = res.data.data.info_integration;
            this.userNextLevel = res.data.data.info_next_level; //下一级vip
            this.userNextIntegral = res.data.data.info_next_integral;
            this.userNextPercent = res.data.data.info_next_percent;
            this.infoBorn = res.data.data.info_born;
            this.infoName = res.data.data.info_name;
            this.infoSex = res.data.data.info_sex;
            this.infoQq =res.data.data.info_qq;
            this.infoArea =res.data.data.info_area;
            this.infoPhone =res.data.data.info_phone;
          }
        })
      },
      submitInfo(value) {
        this.$http.post(`/update_mine_info`,{
          data:{
            info_sex:parseInt(this.infoSex),
            info_qq:this.infoQq,
            info_area:this.infoArea,
            info_phone:this.infoPhone
          }
        }).then(res=>{
          if (res.status==200) {
            alert('已保存!');
            this.queryMineInfo()
          } else {
            alert('保存失败!');
          }               
        })
      },
    }, 
    watch:{
      loginState(value){
        if(value){
          this.queryMineInfo();
        }
      },
      parentIntegral(value){
        if(value > 0){
          this.queryMineInfo();
        }
      }
    }
  };
</script>
<style src="@/assets/css/mine_center.css" scoped></style>
<style>
  .ivu-progress-inner{
    background-color: #e3a17b;
  }

  .ivu-progress-bg{
    background-color: #ff2801;
  }
</style>
